import UploadProfilePictureDialog from './container'
export { UploadProfilePictureDialog }
export default UploadProfilePictureDialog